import { LogVisualizacaoRelatorio } from "./log-visualizacao-relatorio";
import { Relatorio } from "./relatorio";

/**
 * dados de um relatório obrigatório: O log que está sendo visto e o histórico de visualizações
 *
 * @since 20230821
 */
export class RelatorioObrigatorio {
  IdLogVisualizacao: number;
  relatorio: Relatorio;
  logs: LogVisualizacaoRelatorio[];

  constructor(id: number, rel: Relatorio, logs: any[]) {
    this.IdLogVisualizacao = id;
    this.relatorio = rel;
    this.logs = logs.map((l) => {
      const log = Object.assign(new LogVisualizacaoRelatorio(), l);
      log.tratarDadosDaAPI();
      return log;
    });
  }

  /*   tratarDadosDaAPI(): void {
    if (this.logs && this.logs.length > 0) {
      this.logs = this.logs.map((l) => {
        const log = Object.assign(new LogVisualizacaoRelatorio(), l);
        log.tratarDadosDaAPI();
        return log;
      });
    }
  } */
}
